module.exports = {
      id: "icon-help-gray-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-help-gray",
      toString: function () {
        return this.url;
      }
    }